import Flex from 'legacyfrontend/components/Flex';
import timeDiffBetweenDates from 'legacyfrontend/utils/time-diff-between-dates';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  MdOutlineArrowCircleLeft,
  MdOutlineArrowCircleRight,
  MdOutlineChangeCircle,
} from 'react-icons/md';
import { Stack, Typography } from '@mui/material';
import { DATE_KEYS } from 'legacyfrontend/constants';
import { formatWithMomentFormat, utcToLocal } from 'legacyfrontend/utils/dateUtils';
import TooltipScale from 'legacyfrontend/components/flights/FlightCard/TooltipScale';

const iconByMoveCode = {
  start: <MdOutlineArrowCircleRight size={40} />,
  intermediate: <MdOutlineChangeCircle size={40} />,
  end: <MdOutlineArrowCircleLeft size={40} />,
};

const FlightInfoItem = ({
  departureDate,
  arrivalDate,
  travelCode,
  nextDepartureDate,
  originCity,
  destinationCity,
  flightCompany,
  thisMove,
  totalMoves,
}) => {
  const { t } = useTranslation(['layout']);

  const duration = timeDiffBetweenDates(departureDate, arrivalDate);
  const awaitBetweenFlights = nextDepartureDate
    ? timeDiffBetweenDates(arrivalDate, nextDepartureDate)
    : undefined;

  const moveCode = useMemo(
    () => (!thisMove ? 'start' : totalMoves === thisMove ? 'end' : 'intermediate'),
    [totalMoves, thisMove]
  );

  const scale = { isNotScale: true };

  return (
    <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item'>
      <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item__header'>
        <p>{flightCompany ?? '--------'}</p>
        <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item__details__travel-code'>
          COD. {travelCode}
        </Flex>
      </Flex>
      <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item__info'>
        <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item__info__details'>
          <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item__details'>
            <Flex
              className='package-card__dynamic-content__wrapper__flight-list__records__item__info__type'
              title={`${t(`packages.trip_type.${moveCode}`)}${
                moveCode === 'intermediate' ? ` ${thisMove}` : ''
              }`}
            >
              <span
                className={`package-card__dynamic-content__wrapper__flight-list__records__item__info__type__trip-type trip-${moveCode}`}
              >
                {iconByMoveCode[moveCode]}
              </span>
              {moveCode === 'intermediate' && (
                <span className='package-card__dynamic-content__wrapper__flight-list__records__item__info__type__move'>
                  {thisMove}
                </span>
              )}
            </Flex>

            <Stack
              className='flight_card_info'
              sx={{
                flexDirection: 'column',
                paddingLeft: { xs: 0, md: '1rem' },
                paddingRight: { xs: 0, md: '1rem' },
                width: '100%',
              }}
            >
              <Flex className='flight_card_data_jcsb'>
                <Typography fontSize='1rem' fontWeight={700}>
                  {formatWithMomentFormat(utcToLocal(departureDate), DATE_KEYS.FORMAT.FLIGHT)}
                </Typography>
                <Typography fontSize='1rem' fontWeight={700} textAlign='right'>
                  {formatWithMomentFormat(utcToLocal(arrivalDate), DATE_KEYS.FORMAT.FLIGHT)}
                </Typography>
              </Flex>
              <Flex
                style={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                <div className='dashed-line' />

                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'space-between',
                    position: 'relative',
                  }}
                >
                  <TooltipScale escala={scale} />
                  <TooltipScale escala={scale} />
                </div>
              </Flex>
              <Flex className='flight_card_data_jcsb'>
                <p className='bottom_label_flight'>{originCity.codigoCiudad}</p>
                <p className='bottom_label_flight'>{destinationCity.codigoCiudad}</p>
              </Flex>
              <Flex className='flight_card_data_jcsb'>
                <p className='location_text'>{originCity.nombreCiudad}</p>
                <p className='location_text'>{destinationCity.nombreCiudad}</p>
              </Flex>
            </Stack>
          </Flex>
        </Flex>
        <Flex
          className='package-card__dynamic-content__wrapper__flight-list__records__item__end'
          vertical
        >
          <p>
            <strong>{t('packages.duration')}</strong>:{duration}
          </p>
          {awaitBetweenFlights && (
            <p>
              <strong>{t('packages.airport_await')}</strong>: {awaitBetweenFlights}
            </p>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FlightInfoItem;
